import { School, Building2, Landmark, Shield, Flame, Phone, Mail, MapPin, Clock, Siren } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const INSTITUTIONS = [
  {
    icon: School,
    name: "École élémentaire Julien Mercier",
    address: "3 rue Jean Monnet, 28310 Toury",
    phone: "02 37 90 53 03",
    email: "ce.0280651f@ac-orleans-tours.fr",
  },
  {
    icon: School,
    name: "Collège Louis Blériot",
    address: "5 rue du 11 Novembre, 28310 Toury",
    phone: "02 37 90 40 43",
    email: "ce.0280884j@ac-orleans-tours.fr",
  },
  {
    icon: Landmark,
    name: "Mairie de Toury",
    address: "Hôtel de Ville, 5 Place Suger, 28310 Toury",
    phone: "02 37 90 50 60",
    email: "mairie@ville-toury.fr",
    hours: "Lun, mer, jeu, ven : 8h45–12h15 · Mar : 8h45–12h15 et 14h–19h · Sam : 9h–12h",
    logo: "/assets/logo-mairie-toury.png",
  },
  {
    icon: Building2,
    name: "Communauté de communes Cœur de Beauce",
    address: "1 rue du Docteur Casimir Lebel, ZA de l'Ermitage, 28310 Janville-en-Beauce",
    phone: "02 37 90 15 41",
    email: "contact@coeurdebeauce.fr",
    logo: "/assets/logo-coeur-de-beauce.png",
  },
];

const SECOURS = [
  { icon: Shield, name: "Gendarmerie de Janville", address: "17 avenue du Général de Gaulle, 28310 Janville-en-Beauce", phone: "02 37 90 42 39" },
  { icon: Flame, name: "Sapeurs-pompiers de Toury", address: "Centre de secours de Toury", phone: "18" },
  { icon: Siren, name: "Urgences", address: "SAMU : 15 · Police : 17 · Numéro d'urgence européen : 112", phone: "112" },
];

function ContactCard({ icon: Icon, name, address, phone, email, hours, logo, testId }) {
  return (
    <Card className="border-slate-200 hover:shadow-md transition-shadow" data-testid={testId}>
      <CardContent className="p-6 space-y-3">
        <div className="flex items-center gap-3">
          {logo ? (
            <img src={logo} alt={`Logo ${name}`} className="h-14 w-auto max-w-40 object-contain shrink-0" data-testid={`${testId}-logo`} />
          ) : (
            <div className="h-11 w-11 rounded-xl bg-sky-100 flex items-center justify-center shrink-0">
              <Icon className="h-5 w-5 text-sky-700" />
            </div>
          )}
          <h3 className="font-semibold text-slate-800 leading-snug">{name}</h3>
        </div>
        <div className="space-y-1.5 text-sm text-slate-600">
          <p className="flex items-start gap-2"><MapPin className="h-4 w-4 text-slate-400 shrink-0 mt-0.5" />{address}</p>
          <p className="flex items-center gap-2">
            <Phone className="h-4 w-4 text-slate-400 shrink-0" />
            <a href={`tel:${phone.replace(/\s/g, "")}`} className="text-sky-700 font-medium hover:underline" data-testid={`${testId}-phone`}>{phone}</a>
          </p>
          {email && (
            <p className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-slate-400 shrink-0" />
              <a href={`mailto:${email}`} className="text-sky-700 hover:underline" data-testid={`${testId}-email`}>{email}</a>
            </p>
          )}
          {hours && <p className="flex items-start gap-2 text-slate-500"><Clock className="h-4 w-4 text-slate-400 shrink-0 mt-0.5" />{hours}</p>}
        </div>
      </CardContent>
    </Card>
  );
}

export default function UsefulContactsSection() {
  return (
    <div data-testid="useful-contacts-section">
      <h2 className="text-xl font-semibold text-slate-800 mb-5">Écoles & institutions</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12" data-testid="institutions-grid">
        {INSTITUTIONS.map((c, i) => (
          <ContactCard key={i} {...c} testId={`institution-${i}`} />
        ))}
      </div>

      <h2 className="text-xl font-semibold text-slate-800 mb-5">Numéros utiles & secours</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-testid="secours-grid">
        {SECOURS.map((c, i) => (
          <ContactCard key={i} {...c} testId={`secours-${i}`} />
        ))}
      </div>
    </div>
  );
}
